import { lazy } from 'react'

export const CancelOfferSubscriptionVariant1 = lazy(
  () => import('./CancelOfferSubscriptionVariant1'),
)
